module.exports = __webpack_public_path__ + "img/70.e8a818dc.png";